/** Pick train type label from DB fields by UI language (no hardcoded name maps). */

export function localizeTrainType(
  nameRu: string | null | undefined,
  nameEn: string | null | undefined,
  useRu: boolean,
): string {
  const ru = (nameRu || '').trim();
  const en = (nameEn || '').trim();
  if (useRu) return ru || en;
  return en || ru;
}
